import DeviceGroupBannersTab from './DeviceGroupBannersTab';

export default DeviceGroupBannersTab;
